import type { FC } from "react";

import { useCountdown } from "./useCountdown";

interface CountdownTimerProps {
  endsAt: Date;
}

export const CountdownTimer: FC<CountdownTimerProps> = (props) => {
  const { endsAt } = props;

  const [hours, minutes, seconds] = useCountdown(endsAt);

  return (
    <>
      {hours}:{minutes}:{seconds}
    </>
  );
};
